export default class CardList {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.card-list'), el => {
			new CardList(el);
		});
	}

	static classes = {
		node: 'card-list',
		card: 'card',
		get hiddenCard() {
			return CardList.classes.card + '--is-hidden'
		},
		get filter() {
			return CardList.classes.node + '__filter'
		},
		get group() {
			return CardList.classes.node + '__group'
		},
		get hiddenGroup() {
			return CardList.classes.group + '--is-hidden'
		},
		get message() {
			return CardList.classes.node + '__message'
		},
		get hiddenMessage() {
			return CardList.classes.message + '--is-hidden'
		},
		select: {
            get region() {
                return CardList.classes.filter + '__select-region'
            },
            get country() {
				return CardList.classes.filter + '__select-country'
			},
			get category() {
				return CardList.classes.filter + '__select-category'
			}
		}
	}

	constructor(element) {
		if (!element) return;

		this.groups = element.querySelectorAll('.' + CardList.classes.group);
		this.cards = element.querySelectorAll('.' + CardList.classes.card);
		this.regionSelect = element.querySelector('.' + CardList.classes.select.region);
		this.countrySelect = element.querySelector('.' + CardList.classes.select.country);
		this.categorySelect = element.querySelector('.' + CardList.classes.select.category);
		this.message = element.querySelector('.' + CardList.classes.message);

        if(this.regionSelect) this.regionSelect.addEventListener('change', (e) => {
            this.showCards(this.filterCards());
        });

        if(this.countrySelect) this.countrySelect.addEventListener('change', (e) => {
			this.showCards(this.filterCards());
		});

		if(this.categorySelect) this.categorySelect.addEventListener('change', (e) => {
			this.showCards(this.filterCards());
		});
	}

	filterCards() {
		return Array.prototype.filter.call(this.cards, card => {
			let filter = JSON.parse(card.dataset.filter) || {};
			let isInCardsRegions = !this.regionSelect || this.regionSelect.value === '' || (filter.regions && filter.regions.indexOf(this.regionSelect.value) !== -1);
			let isInCardsCountries = !this.countrySelect || this.countrySelect.value === '' || (filter.countries && filter.countries.indexOf(this.countrySelect.value) !== -1);
			let isInCardsCategories = !this.categorySelect || this.categorySelect.value === '' || (filter.categories && filter.categories.indexOf(this.categorySelect.value) !== -1);

			return isInCardsRegions && isInCardsCountries && isInCardsCategories;
		});
	}

	showCards(cards) {
		this.message.classList[cards.length === 0 ? 'remove': 'add'](CardList.classes.hiddenMessage);

		this.hideCards(this.excludeFilter());

		Array.prototype.forEach.call(cards, card => {
			card.classList.remove(CardList.classes.hiddenCard)
		});

		Array.prototype.forEach.call(this.groups, group => {
			let cardsCount = group.querySelectorAll('.' + CardList.classes.card).length;
			let hiddenCardsCount = group.querySelectorAll('.' + CardList.classes.hiddenCard).length;

			group.classList[cardsCount === hiddenCardsCount ? 'add': 'remove'](CardList.classes.hiddenGroup);
		});
	}

	hideCards(cards) {
		Array.prototype.forEach.call(cards, card => {
			card.classList.add(CardList.classes.hiddenCard)
		});
	}

	excludeFilter() {
		return Array.prototype.filter.call(this.cards, el => !this.filterCards().includes(el));
	}
}
